<template>
  <j-modal
    :title="title"
    :width="800"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :maskClosable="false"
    :body-style="{ height: '380px', overflow: 'hidden', overflowY: 'scroll' }"
    @ok="handleOk"
    @cancel="handleCancel"
    :okText="$t('确定')"
    :cancelText="$t('关闭')"
    :okButtonProps="{ class: { 'jee-hidden': disableSubmit } }"
  >
    <a-spin :spinning="confirmLoading">
      <div>
        <div style="display: flex">
          <div style="flex: 1">
            <a-form-model-item :label="$t('协议附件:')" class="notcolor">
              <JUpload v-model="fileList" :buttonVisible="false" />
            </a-form-model-item>
            <a-form-model-item :label="$t('协议签名:')" class="notcolor">
              <j-image-upload
                class="avatar-uploader"
                :text="$t('上传')"
                :isMultiple="true"
                v-model="userInfo.image"
                :disabled="true"
              ></j-image-upload>
            </a-form-model-item>
            <!-- <detail-list :col="1">
              <detail-list-item term="协议附件">
                <JUpload v-model="fileList" :buttonVisible="false"/>
              </detail-list-item>
              <detail-list-item term="协议签名">
                <j-image-upload class="avatar-uploader" text="上传" :isMultiple="true" v-model="userInfo.image" :disabled="true"></j-image-upload>
              </detail-list-item>
            </detail-list> -->
            <!-- <a target="_blank" :href="aa">{{ $t('测试附件') }}</a>
            <a-button type="primary" @click="openFile">
                打开附件
            </a-button> -->
          </div>
        </div>
        <div style="display: flex; justify-content: center">
          <a-button type="primary" @click="onWaterAgreement">{{ $t('发送协议') }}</a-button>
        </div>
      </div>
    </a-spin>
  </j-modal>
</template>

<script>
import { uploadAction, postAction } from '@/api/manage'
import DetailList from '@/components/tools/DetailList'
const DetailListItem = DetailList.Item
import JUpload from '@/components/jeecg/JUpload'
import JImageUpload from '@/components/jeecg/JImageUpload.vue'
import Vue from 'vue'
export default {
  name: 'WaterAgreementModal',
  components: {
    DetailList,
    DetailListItem,
    JUpload,
    JImageUpload,
  },
  data() {
    return {
      title: '',
      width: 800,
      visible: false,
      disableSubmit: false,
      confirmLoading: false,
      userId: '',
      userInfo: {},
      fileList: [],
      // 业务类型: 用水/过户/报停/销户
      contractType: '',
      // 用于生成合同PDF的用户信息(由调用方透传)
      userFields: {},
      // 生成PDF中,防重复点击
      sending: false,
      url: {
        upload: 'sys/common/upload',
        // 按用户信息生成供水合同PDF,返回Base64
        generatePdf: '/jeecg-charge/contract/generatePdf',
      },
      aa: '',
    }
  },
  methods: {
    openFile() {
      window.open(window._CONFIG['staticDomainURL'] + '/' + this.userInfo.file)
    },
    // type: 业务类型 用水/过户/报停/销户
    // userFields: 用于生成合同PDF的用户信息 { userName, userAddr, userPhone, userIdNumber, waterUseType, contractNo, signDateText }
    // file/image: 已有协议附件和签名(回显用),可空
    init(type, userFields, file, image) {
      this.title = this.$t('协议')
      this.visible = true
      this.userId = userFields.userId
      console.log('params:', userFields)

      this.contractType = type || '用水'
      this.userFields = userFields || {}
      this.$nextTick(() => {
        if (file) {
          this.userInfo = {
            file: file,
          }
          this.aa = window._CONFIG['staticDomainURL'] + '/' + this.userInfo.file
          this.fileList = [file]
        } else {
          this.userInfo = {}
          this.fileList = []
        }
        if (image) {
          this.userInfo.image = image
        } else {
          this.userInfo.image = ''
        }
      })
      this.initWebSocket()
    },
    handleOk() {
      this.$emit('ok', this.userInfo)
      this.close()
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    handleCancel() {
      this.close()
    },
    // 点击“发送协议”：先调后端按用户信息生成合同PDF(Base64)，再用 szPdfData 下发高拍仪电签。
    // 协议 7.1.1 star_StartPDFSign：未传 szPdfPath 时使用 szPdfData(PDF的Base64)。
    onWaterAgreement() {
      if (this.sending) return
      this.sending = true
      this.$message.success(this.$t('正在生成协议，请稍等！'))
      // let params = Object.assign({ contractType: this.contractType }, this.userFields);
      postAction(this.url.generatePdf + '?userId=' + this.userId, null)
        .then(res => {
          if (res.success || res.code == 200) {
            let pdfBase64 = res.result
            if (!pdfBase64) {
              this.sending = false
              this.$message.error(this.$t('生成协议失败：未返回PDF数据'))
              return
            }
            // 用 szPdfData(Base64) 下发，不再依赖本地 szPdfPath
            let json = {
              Type: '5',
              // Method: 'star_StartPDFSign',
              // 新的接口
              Method: 'GWQ_StartSignWithRec',
              nPort: '0',
              nBaud: '9600',
              cBp: '0',
              nPage: '0',
              nX: '1000',
              nY: '1000',
              nW: '100',
              nH: '30',
              nHandPage: '3',
              nHandX: '370',
              nHandY: '305',
              nVoiceType: '0',
              szVoice: '语音测试',
              szTitle: '查看协议',
              nEndVoiceType: '0',
              szEndVoice: '谢谢',
              nOperationType: '1',
              nTimeout: '60',
            }
            // json.szPdfPath = 'D:\\test.pdf'
            console.log('json:', json)
            json.szPdfData = pdfBase64
            this.websocketSend(JSON.stringify(json))
            this.$message.success(this.$t('发送协议中，请在高拍仪上签字！'))
          } else {
            this.$message.error(this.$t('生成协议失败：') + (res.message || this.$t('未知错误')))
          }
        })
        .catch(err => {
          this.$message.error(this.$t('生成协议异常：') + (err && err.message ? err.message : err))
        })
        .finally(() => {
          this.sending = false
        })
    },
    // websocket消息通知开始
    initWebSocket() {
      // WebSocket与普通的请求所用协议有所不同，ws等同于http，wss等同于https
      var userId = this.$store.getters.userInfo.id
      // var url = window._CONFIG['domianURL'].replace("https://", "wss://").replace("http://", "ws://") + "/websocket/" + userId;
      // var url = 'ws://localhost:19998/'
      // var url = 'http://172.16.8.137:19998/'
      var url = 'http://127.0.0.1:19998/'

      //update-begin-author:taoyan date:2022-4-22 for:  v2.4.6 的 websocket 服务端，存在性能和安全问题。 #3278
      let token = Vue.ls.get('ACCESS_TOKEN')

      this.websocket = new WebSocket(url)
      //update-end-author:taoyan date:2022-4-22 for:  v2.4.6 的 websocket 服务端，存在性能和安全问题。 #3278
      this.websocket.onopen = this.websocketOnopen
      this.websocket.onerror = this.websocketOnerror
      this.websocket.onmessage = this.websocketOnmessage
      this.websocket.onclose = this.websocketOnclose
    },
    websocketOnopen() {
      console.log('WebSocket消息通知layout连接成功')
      //心跳检测重置
      // this.heartCheck.reset().start();
    },
    websocketOnerror(e) {
      console.log('WebSocket连接发生错误，第%s次', this.wsConnectErrorTime)

      this.wsConnectErrorTime = this.wsConnectErrorTime + 1
      if (this.wsConnectErrorTime > 5) {
        console.log('WebSocket连接错误超过5次，就不再重新连了！')
        this.lockReconnect = true
        return
      }
      // this.reconnect();
    },
    websocketOnmessage(e) {
      let data = JSON.parse(e.data) //解析json字符串
      console.log('WebSocket消息通知layout收到消息', data)
      if (data.Type === '5') {
        // 电签结果
        var szPicData = ''
        var szPdfData = ''
        if (data.Method === 'star_StartPDFSign') {
          if (data.ret === '0') {
            // 无纸化-PDF电签
            szPicData = data.szPicData
            szPdfData = data.szPdfData
            this.base64ToUrl(szPicData, 'image')
            this.base64ToUrl(szPdfData, 'pdf')
          } else {
            this.$message.error(this.$t('电签失败！请联系管理员并提供错误代码 :') + data.ret)
          }
        } else if (data.Method === 'GWQ_StartSignWithRec') {
          if (data.ret === '0') {
            // 无纸化-PDF电签
            szPdfData = data.szSignPdfBase64
            // 新协议: 签名为多笔, szSignNameBase64 为 JSON 字符串
            // { SignNameCount: N, SignName0: base64, SignName1: base64, ... }
            szPicData = data.szSignNameBase64
            this.base64ToUrl(szPdfData, 'pdf')
            this.handleMultiSign(szPicData)
          } else {
            this.$message.error(this.$t('电签失败！请联系管理员并提供错误代码:') + data.ret)
          }
        } else {
          this.$message.error(this.$t('电签失败！请联系管理员'))
        }
      }else {
        this.$message.success(this.$t('收到未匹配的消息：') + data.Type)
      }
    },
    // 处理多笔签名: szSignNameBase64 为 JSON 字符串
    // 格式: { SignNameCount: N, SignName0: base64, SignName1: base64, ... }
    // 多笔签名上传完成后, 用逗号拼接保存到 userInfo.image 同一字段
    // 兼容旧协议(直接 base64)及非合法 JSON 的情况
    handleMultiSign(signNameBase64) {
      if (!signNameBase64) {
        this.$message.warning(this.$t('未收到签名图片数据'))
        return
      }
      let parsed
      try {
        parsed = JSON.parse(signNameBase64)
      } catch (e) {
        // 非 JSON: 兼容旧协议的直接 base64
        console.warn('szSignNameBase64 不是 JSON, 按单张签名处理', e)
        this.base64ToUrl(signNameBase64, 'image')
        return
      }
      // 签名个数: 优先用 SignNameCount, 否则按存在的 SignName{i} 推断
      let count = parseInt(parsed.SignNameCount, 10)
      if (isNaN(count) || count < 0) {
        count = 0
        while (parsed['SignName' + count] !== undefined && parsed['SignName' + count] !== null && parsed['SignName' + count] !== '') {
          count++
        }
      }
      if (count === 0) {
        this.$message.warning(this.$t('未解析到签名图片'))
        return
      }
      // 先清空旧签名, 收集每笔签名的上传结果, 全部完成后逗号拼接写入
      this.$set(this.userInfo, 'image', '')
      let tasks = []
      for (let i = 0; i < count; i++) {
        const imgBase64 = parsed['SignName' + i]
        if (imgBase64) {
          tasks.push(this.base64ToUrl(imgBase64, 'image'))
        }
      }
      Promise.all(tasks).then(urls => {
        const valid = urls.filter(u => !!u)
        if (valid.length > 0) {
          this.$set(this.userInfo, 'image', valid.join(','))
        }
      })
    },
    // 返回 Promise, resolve(上传后的文件路径 message); 失败 resolve('')
    base64ToUrl(base64, type) {
      console.log('开始上传协议'+ type, base64)
      var pdfUrl = atob(base64)
      var pdfNumbers = pdfUrl.length
      var pdfArray = new Uint8Array(pdfNumbers)
      while (pdfNumbers--) {
        pdfArray[pdfNumbers] = pdfUrl.charCodeAt(pdfNumbers)
      }
      var file = ''
      if (type == 'pdf') {
        file = new File([pdfArray], '协议附件.pdf', { type: 'application/pdf' })
      } else {
        file = new File([pdfArray], '协议签名.png', { type: 'image/png' })
      }
      let formData = new FormData()
      formData.append('biz', 'temp')
      formData.append('file', file)
      console.log('上传协议'+ this.url.upload, formData)
      return uploadAction(this.url.upload, formData).then(res => {
        if (res.success) {
          console.log(res.message)
          if (type == 'pdf') {
            this.fileList = []
            this.$set(this.userInfo, 'file', res.message)
            this.fileList.push(res.message)
          } else {
            // 多笔签名由 handleMultiSign 统一拼接, 这里只暂存本次上传结果
            this.$set(this.userInfo, 'image', res.message)
          }
          return res.message
        }
        return ''
      }).catch(() => '')
    },
    websocketOnclose(e) {
      console.log('connection closed (' + e + ')')
      if (e) {
        console.log('connection closed (' + e.code + ')')
      }
      // this.reconnect();
    },
    websocketSend(text) {
      // 数据发送
      try {
        this.websocket.send(text)
      } catch (err) {
        console.log('send failed (' + err.code + ')')
      }
    },
  },
}
</script>
<style scoped>
/deep/.detail-list .content {
  line-height: normal;
}
/deep/.notcolor .ant-form-item-label > label {
  color: #999999;
}
</style>